<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <input-form-penilaian :tables="[
        {
          name: 'ASSESOR DOKUMEN PERIZINAN PERUSAHAAN',
          obj_name: 'jenis',
          css: 'column40 mr10',
          input: false,
          type: 'name',
        },
        {
          name: 'BOBOT (20%)',
          obj_name: 'bidang',
          css: 'column10',
          input: false,
          type: 'subname',
        },
        {
          name: 'NILAI',
          obj_name: 'sub_bidang',
          css: 'column10',
          input: true,
          type: 'select',
        },
        {
          name: 'CATATAN',
          obj_name: 'sub_bidang',
          css: 'column40',
          input: true,
          type: 'text',
        },
      ]" :listInput="[
        {
          type: 'label',
          label: 'IUJP/SIUP',
        },
        {
          type: 'form',
          name: 'ITEM 1.1',
          subname: '25%',
          options: ['N/A', '0', '5'],
          optionStore: 'izin_11',
          inputStore: 'note_izin_11',
        },
        {
          type: 'form',
          name: 'ITEM 1.2',
          subname: '75%',
          options: ['N/A', '0', '15'],
          optionStore: 'izin_12',
          inputStore: 'note_izin_12',
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="$store.state.k3lStore.is_preview" />
      <desc-penilaian :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column20 col-nohover',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover',
        },
        {
          title: 'title_4',
          desc: 'desc_4',
          css: 'column30 col-nohover',
        },
      ]" :listInput="[
        {
          head: [
            {
              title_1: 'BOBOT NILAI',
              title_2: '0',
              title_3: '-',
              title_4: '5',
            },
          ],
          item: [
            {
              desc_1: 'ITEM 1.1',
              desc_2:
                'Tidak ada dokumen IUJP &/ SIUP &/ NIB sesuai bidang kerja.',
              desc_3: '-',
              desc_4: 'Dokumen IUJP &/ SIUP &/ NIB sesuai bidang kerja.',
            },
          ],
        },
        {
          head: [
            {
              title_1: 'BOBOT NILAI',
              title_2: '0',
              title_3: '-',
              title_4: '15',
            },
          ],
          item: [
            {
              desc_1: 'ITEM 1.2',
              desc_2: 'Dokumen Perizinan tidak berlaku atau expired.',
              desc_3: '-',
              desc_4: 'Dokumen Perizinan IUJP &/ SIUP &/ NIB masih berlaku.',
            },
          ],
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="$store.state.k3lStore.is_preview" />

      <input-doc :label="'Perizinan'" :modelName="'addedPerizinan'" :isRequired="false"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :modalName="'modal_add_perizinan'"
        :disabled="true" />
      <input-select-table :label="'Bidang Usaha Pertambangan Inti'" :tables="[
        {
          name: 'Jenis',
          obj_name: 'jenis',
          css: 'column10 mr10',
        },
        {
          name: 'Bidang',
          obj_name: 'bidang',
          css: 'column40',
        },
        {
          name: 'Sub Bidang',
          obj_name: 'sub_bidang',
          css: 'column40',
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="true" />
      <input-fill-form :label="'Bidang Usaha Pertambangan Non Inti'" :tables="[
        {
          name: 'Bidang',
          obj_name: 'desc',
          css: 'column30 mr10 all-column',
          input: false,
          type: '',
        },
        {
          name: 'Penjelasan',
          obj_name: 'penjelasan',
          css: 'column70',
          input: true,
          type: 'text',
        },
      ]" :isRequired="false" :modalName="'modal_add_iujp_non_inti'" :modelName="'addedIUJPnonInti'"
        :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :disabled="true" />
      <input-form-penilaian :tables="[
        {
          name: 'ASSESOR KOMPETENSI DAN SUMBER DAYA MANUSIA',
          obj_name: 'jenis',
          css: 'column40 mr10',
          input: false,
          type: 'name',
        },
        {
          name: 'BOBOT (15%)',
          obj_name: 'bidang',
          css: 'column10',
          input: false,
          type: 'subname',
        },
        {
          name: 'NILAI',
          obj_name: 'sub_bidang',
          css: 'column10',
          input: true,
          type: 'select',
        },
        {
          name: 'CATATAN',
          obj_name: 'sub_bidang',
          css: 'column40',
          input: true,
          type: 'text',
        },
      ]" :listInput="[
        {
          type: 'label',
          label: 'KOMPETENSI UMUM',
        },
        {
          type: 'form',
          name: 'ITEM 1.1',
          subname: '33.33%',
          options: ['N/A', '0', '3', '5'],
          optionStore: 'sertifikat_11',
          inputStore: 'note_sertifikat_11',
        },
        {
          type: 'label',
          label: 'KOMPETENSI KHUSUS',
        },
        {
          type: 'form',
          name: 'ITEM 1.1',
          subname: '33.33%',
          options: ['N/A', '0', '3', '5'],
          optionStore: 'sertifikat_12',
          inputStore: 'note_sertifikat_12',
        },
        {
          type: 'form',
          name: 'ITEM 1.2',
          subname: '33.33%',
          options: ['N/A', '0', '3', '5'],
          optionStore: 'sertifikat_13',
          inputStore: 'note_sertifikat_13',
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="$store.state.k3lStore.is_preview" />
      <desc-penilaian :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column20 col-nohover',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover',
        },
        {
          title: 'title_4',
          desc: 'desc_4',
          css: 'column30 col-nohover',
        },
      ]" :listInput="[
        {
          head: [
            {
              title_1: 'BOBOT NILAI',
              title_2: '0',
              title_3: '3',
              title_4: '5',
            },
          ],
          item: [
            {
              type: 'label',
              label: 'KOMPETENSI UMUM',
            },
            {
              type: 'desc',
              desc_1: 'ITEM 1.1',
              desc_2:
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
              desc_3: [
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
                '2. Sertifikasi Kompetensi K3 (AK3 U/ POP) < 50% dari jumlah total karyawan dengan posisi/ jabatan level pengawas. ',
              ],
              desc_4: [
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
                '2. Sertifikasi Kompetensi K3 (AK3 U/ POP) >= 50% dari jumlah total karyawan dengan posisi/ jabatan level pengawas. ',
              ],
            },
            {
              type: 'label',
              label: 'KOMPETENSI KHUSUS',
            },

            {
              type: 'desc',
              desc_1: 'ITEM 1.1',
              desc_2:
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
              desc_3: [
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
                '2. Sertifikasi Kompetensi K3 (AK3 U/ POP) < 50% dari jumlah total karyawan dengan posisi/ jabatan level pengawas. ',
              ],
              desc_4: [
                '1. Struktur organisasi (posisi / jabatan & nama pekerja).',
                '2. Sertifikasi Kompetensi K3 (AK3 U/ POP) >= 50% dari jumlah total karyawan dengan posisi/ jabatan level pengawas. ',
              ],
            },
            {
              type: 'desc',
              desc_1: 'ITEM 1.2',
              desc_2:
                '1. Daftar karyawan yang memiliki kompetensi khusus sesuai jabatan dan bidang kerjanya',
              desc_3: [
                '1. Daftar karyawan yang memiliki kompetensi khusus sesuai jabatan dan bidang kerjanya.',
                '2. Sertifikasi Kompetensi khusus sesuai bidang kerja (Welder, SIO alat angkat , SIO riger, Scafolder, AK3 Listrik, dll) < 50% dari jumlah total karyawan yang memiliki kompetensi khusus. ',
              ],
              desc_4: [
                '1. Daftar karyawan yang memiliki kompetensi khusus sesuai jabatan dan bidang kerjanya.',
                '2. Sertifikasi Kompetensi khusus sesuai bidang kerja (Welder, SIO alat angkat , SIO riger, Scafolder, AK3 Listrik, dll) >= 50% dari jumlah total karyawan yang memiliki kompetensi khusus. ',
              ],
            },
          ],
        },
      ]" :modelName="'addedIUJP'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
        :modalName="'modal_add_iujp'" :disabled="true" />
      <input-upload :label="'Lampiran dokumen Struktur Organisasi Perusahaan (Posisi/Jabatan & Nama Pekerja)'
        " :modelName="'structurOrgFile'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :disabled="true" />
      <input-fill-form :label="'Isi tabel daftar karyawan yang memiliki sertifikat kompetensi K3 dan atau kompetensi khusus sesuai jabatan dan bidangnya'
        " :tables="[
          {
            name: 'Posisi',
            obj_name: 'posisi',
            css: 'column20',
            input: false,
            type: '',
          },
          {
            name: 'Jumlah Karyawan',
            obj_name: 'jumlah',
            css: 'column20 mr10 all-column',
            input: false,
            type: '',
          },
          {
            name: 'Kompetensi Umum / Khusus',
            obj_name: 'umum_khusus',
            css: 'column20 mr10 all-column',
            input: false,
            type: '',
          },
          {
            name: 'Pengalaman Kerja (Tahun)',
            obj_name: 'pengalaman_kerja',
            css: 'column20 mr10 all-column',
            input: false,
            type: '',
          },
          {
            name: 'Dokumen Pendukung',
            obj_name: 'sertifikat_karyawan',
            css: 'column20 mr10 all-column',
            input: false,
            type: 'file',
          },
        ]" :modelName="'addedCompetencies'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'" :modalName="'modal_add_competencies'" :disabled="true" />
      <notes :items="[
        '<strong>*Catatan</strong>',
        '1. <strong>Kompetensi Umum -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian umum yang tidak berdampak kepada kejadian LTI & fatality.',
        '2. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Umum</strong> K3 (AK3 Umum/POP) - AK3 Umum/POP/ISM Code/sertifikat K3 lainnya.',
        '3. <strong>Kompetensi Khusus -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian khusus yang dapat berdampak kepada kejadian LTI & fatality.',
        '4. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Khusus</strong> (POP/POU) sesuai bidang kerja - Welder, SIO alat angkat, SIO riger, Scafolder, AK3 Listrik, KIM, dll.',
        '5. <strong>Pengalaman Kerja -</strong> Penjelasan Umum Pengalaman Kerja Sebelumnya, Rata-rata Jumlah Tahun Pengalaman',
      ]" />
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan & Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputDoc from '../../components/forms/input-doc.vue'
import InputSelectTable from '../../components/forms/input-select-table.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
import InputUpload from '../../components/forms/input-upload.vue'
import Notes from '../../components/layout/notes.vue'
import InputFormPenilaian from '../../components/forms/input-form-penilaian.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    InputDoc,
    InputSelectTable,
    InputFillForm,
    InputUpload,
    Notes,
    InputFormPenilaian,
    DescPenilaian,
  },
  data() {
    return {}
  },
  async created() {
    await this.$store.commit('k3lStore/CALCULATION_1')
    await this.$store.commit('k3lStore/CALCULATION_2')
    await this.$store.commit('k3lStore/CALCULATION_3')
  },
  watch: {
    '$store.state.k3lStore.izin_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_1')
    },
    '$store.state.k3lStore.izin_12'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_1')
    },
    '$store.state.k3lStore.sertifikat_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_2')
    },
    '$store.state.k3lStore.sertifikat_12'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_2')
    },
    '$store.state.k3lStore.sertifikat_13'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_2')
    },
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'profile' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_SIPM_SUBMIT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup13' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
